import { bondFormFileUrlQueryKey } from "@portal/api/bond";
import type { SuretyBond } from "@portal/api/bond/agent";
import { PDFViewer, type PDFViewerControl } from "@portal/components/patterns/pdf-viewer";
import { Card, Text } from "@portal/components/primitives";
import { type FC, useMemo } from "react";

const VIEWER_OPTIONS = { fitToWidth: true };

export const AgentBondFormTab: FC<{ bond: SuretyBond }> = ({ bond }) => {
	const control = useMemo<PDFViewerControl>(
		() => ({
			fetchUrl: `/v2/surety/bonds/${bond.id}/bond-form`,
			queryKey: bondFormFileUrlQueryKey(bond.id),
		}),
		[bond.id],
	);

	return (
		<Card elevation="raised" className="rounded-xl" data-testid="agent-bond-form-card">
			<Card.Body className="p-6">
				<div className="flex w-full flex-col space-y-5">
					<Text color="primary" type="title">
						Bond Form
					</Text>
					<PDFViewer
						control={control}
						options={VIEWER_OPTIONS}
						className="h-[830px] w-full"
						testId="agent-bond-form-pdf"
						trackingId="agent-bond-form-viewer"
					/>
				</div>
			</Card.Body>
		</Card>
	);
};
